<template>
    <div>
        <page-title-bar class="pb-1"></page-title-bar>
        <v-container fluid pt-0>
            <v-layout row wrap border-rad-sm overflow-hidden>
                <app-card colClasses="xs12">
                    <vue-perfect-scrollbar :settings="settingsScroll">
                        <v-list two-line class="card-list">
                            <template v-if="permisos.mipres.edit">
                                <v-subheader>Tokens</v-subheader>
                                <v-list-tile avatar>
                                    <v-list-tile-avatar>
                                        <v-icon class="success white--text">ti ti-shield</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-sub-title>
                                            <h5 class="mb-1">
												{{typeEmpresa === 'IPS'
												? 'Configuración de tokens principales'
												: 'Configuración de token principal'}}
											</h5>
                                            <v-list-tile-action-text class="fw-light">
                                                {{typeEmpresa === 'IPS'
												? 'Tokens principales de IPS y Proveedor para la activación de transacciones.'
												: 'Token principal de proveedor para la activación de transacciones.'}}
                                            </v-list-tile-action-text>
                                        </v-list-tile-sub-title>
                                        <template v-if="typeEmpresa === 'IPS'">
                                            <p class="mb-0 fs-12 grey--text fw-normal">
                                                Token IPS: {{ (!!tokensMIPRES.mipres && !!tokensMIPRES.mipres.token)
                                                ? tokensMIPRES.mipres.token
                                                : 'No registrado' }}
                                            </p>
                                            <p class="mb-0 fs-12 grey--text fw-normal">
                                                Token Proveedor: {{ (!!tokensMIPRES.mipres_facturacion && !!tokensMIPRES.mipres_facturacion.token)
                                                ? tokensMIPRES.mipres_facturacion.token
                                                : 'No registrado' }}
                                            </p>
                                        </template>
                                        <p class="mb-0 fs-12 grey--text fw-normal" v-else>
                                            Token Proveedor: {{ (!!tokensMIPRES.mipres && !!tokensMIPRES.mipres.token)
                                            ? tokensMIPRES.mipres.token
                                            : 'No registrado' }}
                                        </p>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn
                                                color="info"
                                                small
                                                @click="openRegisterMainToken"
                                        >
                                            Ejecutar
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-list-tile avatar v-if="tokensMIPRES.mipres && tokensMIPRES.mipres.token">
                                    <v-list-tile-avatar>
                                        <v-icon class="success white--text">ti ti-reload</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-sub-title>
                                            <h5 class="mb-1" v-if="typeEmpresa === 'IPS'">
												{{(!!tokensMIPRES.suministros && !!tokensMIPRES.facturacion && !!tokensMIPRES.suministros.token && !!tokensMIPRES.facturacion.token)
												? 'Actualizar tokens diarios' :
                                                'Registrar tokens diarios'}}
											</h5>
                                            <h5 class="mb-1" v-else>
												{{(!!tokensMIPRES.suministros && !!tokensMIPRES.suministros.token)
												? 'Actualizar token diario' :
                                                'Registrar token diario'}}
											</h5>
                                            <v-list-tile-action-text class="fw-light">
                                                {{typeEmpresa === 'IPS'
                                                ? 'Tokens diarios de suministro y facturación para el procesamiento de datos MIPRES.'
                                                : 'Token diario de suministro para el procesamiento de datos MIPRES.'}}
                                            </v-list-tile-action-text>
                                        </v-list-tile-sub-title>
                                        <p class="mb-0 fs-12 grey--text fw-normal" v-if="typeEmpresa === 'IPS'">
											Token facturación:
                                            {{(!!tokensMIPRES.facturacion && !!tokensMIPRES.facturacion.token) ?
                                            tokensMIPRES.facturacion.token : 'No registra'}}
										</p>
										<p class="mb-0 fs-12 grey--text fw-normal">
											Token suministros:
                                            {{(!!tokensMIPRES.suministros && !!tokensMIPRES.suministros.token) ?
                                            tokensMIPRES.suministros.token : 'No registra'}}
										</p>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn
                                                color="info"
                                                small
                                                @click="openConfirmTokenDaily"
                                        >
                                            Ejecutar
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </template>
                            <template v-if="tokensMIPRES.mipres && tokensMIPRES.suministros">
                                <template v-if="permisos.prescripciones.descargar">
                                    <v-subheader>Prescripciones</v-subheader>
                                    <v-list-tile avatar v-for="downloadLink in donwloadLinksPrescripcion"
                                                 :key="'Pres' + downloadLink.id">
                                        <v-list-tile-avatar>
                                            <v-icon class="white--text" :class="downloadLink.color">
                                                {{downloadLink.icon}}
                                            </v-icon>
                                        </v-list-tile-avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-sub-title>
                                                <h5 class="mb-1">{{downloadLink.title}}</h5>
                                                <v-list-tile-action-text class="fw-light">
                                                    {{downloadLink.subTitle}}
                                                </v-list-tile-action-text>
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
                                            <v-btn
                                                    color="info"
                                                    small
                                                    @click="openDialogDownloadPrescripciones(downloadLink.type)"
                                            >
                                                Ejecutar
                                            </v-btn>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </template>
                                <template v-if="permisos.direccionamientos.descargar">
                                    <v-subheader>Direccionamientos</v-subheader>
                                    <v-list-tile avatar v-for="downloadLink in donwloadLinksDireccionamiento"
                                                 :key="'Dir' + downloadLink.id">
                                        <v-list-tile-avatar>
                                            <v-icon class="white--text" :class="downloadLink.color">
                                                {{downloadLink.icon}}
                                            </v-icon>
                                        </v-list-tile-avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-sub-title>
                                                <h5 class="mb-1">{{downloadLink.title}}</h5>
                                                <v-list-tile-action-text class="fw-light">
                                                    {{downloadLink.subTitle}}
                                                </v-list-tile-action-text>
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
                                            <v-btn
                                                    color="info"
                                                    small
                                                    @click="openDialogDownloadDireccionamientos(downloadLink.type)"
                                            >
                                                Ejecutar
                                            </v-btn>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </template>
                                <template v-if="permisos.programaciones.descargar">
                                    <v-subheader>Programaciones</v-subheader>
                                    <v-list-tile avatar v-for="downloadLink in donwloadLinksProgramacion"
                                                 :key="'Pro' + downloadLink.id">
                                        <v-list-tile-avatar>
                                            <v-icon class="white--text" :class="downloadLink.color">
                                                {{downloadLink.icon}}
                                            </v-icon>
                                        </v-list-tile-avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-sub-title>
                                                <h5 class="mb-1">{{downloadLink.title}}</h5>
                                                <v-list-tile-action-text class="fw-light">
                                                    {{downloadLink.subTitle}}
                                                </v-list-tile-action-text>
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
                                            <v-btn
                                                    color="info"
                                                    small
                                                    @click="openDialogDownloadProgramaciones(downloadLink.type)"
                                            >
                                                Ejecutar
                                            </v-btn>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </template>
                                <template
                                        v-if="permisos.prescripciones.descargar || permisos.prescripciones.sincronizar">
                                    <v-subheader>Historicos</v-subheader>
                                    <v-list-tile avatar v-for="downloadLink in donwloadLinksHistorico"
                                                 :key="'His' + downloadLink.id"
                                                 v-if="downloadLink.show.includes(typeEmpresa)">
                                        <v-list-tile-avatar>
                                            <v-icon class="white--text" :class="downloadLink.color">
                                                {{downloadLink.icon}}
                                            </v-icon>
                                        </v-list-tile-avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-sub-title>
                                                <h5 class="mb-1">{{downloadLink.title}}</h5>
                                                <v-list-tile-action-text class="fw-light">
                                                    {{downloadLink.subTitle}}
                                                </v-list-tile-action-text>
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
                                            <v-btn
                                                    color="info"
                                                    small
                                                    @click="openDialogDownloadHistorico(downloadLink.type, downloadLink.url)"
                                            >
                                                Ejecutar
                                            </v-btn>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </template>
                            </template>
                        </v-list>
                        <app-section-loader :status="processing"></app-section-loader>
                    </vue-perfect-scrollbar>
                </app-card>
            </v-layout>
        </v-container>
        <template v-if="permisos.mipres.edit">
            <register-main-token-dialog
                    ref="dialogRegisterMainToken"
            >
            </register-main-token-dialog>
            <confirmation-dialog
                    ref="dialogTokenDaily"
                    heading="¿Seguro de continuar?"
                    :message="`¿Está seguro de continuar con el restablecimiento de${typeEmpresa === 'IPS' ? ' los tokens diarios' : 'l token diario'}?`"
                    @onConfirm="refreshTokenDaily"
            >
            </confirmation-dialog>
        </template>
        <download-prescripciones-dialog
                v-if="permisos.prescripciones.descargar"
                ref="dialogDPres"
                :type="typeDownloadPrescripcion"
                @onProcessing="val => processing = val"
        >
        </download-prescripciones-dialog>
        <download-direccionamientos-dialog
                v-if="permisos.direccionamientos.descargar"
                ref="dialogDD"
                :type="typeDownloadDireccionamiento"
                @onProcessing="val => processing = val"
        >
        </download-direccionamientos-dialog>
        <download-programaciones-dialog
                v-if="permisos.programaciones.descargar"
                ref="dialogDP"
                :type="typeDownloadProgramacion"
                @onProcessing="val => processing = val"
        >
        </download-programaciones-dialog>
        <download-historico-dialog
                v-if="permisos.prescripciones.descargar || permisos.prescripciones.sincronizar"
                ref="dialogDH"
                :type="typeDownloadHistorico"
                @onProcessing="val => processing = val"
        >
        </download-historico-dialog>
    </div>
</template>

<script>
    import {mapState, mapGetters} from 'vuex'

    export default {
        components: {
            DownloadPrescripcionesDialog: () => import('@/components/Prescripciones/DownloadPrescripcionesDialog'),
            DownloadDireccionamientosDialog: () => import('@/components/Direccionamientos/DownloadDireccionamientosDialog'),
            DownloadProgramacionesDialog: () => import('@/components/Programaciones/DownloadProgramacionesDialog'),
            RegisterMainTokenDialog: () => import('@/components/Mipres/RegisterMainTokenDialog')
        },
        data: () => ({
            settingsScroll: {
                maxScrollbarLength: 160
            },
            donwloadLinksPrescripcion: [
                {
                    id: 1,
                    title: 'Prescripciones por fecha',
                    subTitle: 'Descarga de prescripciones especificando una fecha',
                    icon: 'ti ti-pencil-alt',
                    color: 'purple',
                    type: 'date'
                },
                {
                    id: 2,
                    title: 'Prescripción por número',
                    subTitle: 'Descargar registro especificando el número de prescripción',
                    icon: 'ti ti-pencil-alt',
                    color: 'info',
                    type: 'number'
                }
            ],
            donwloadLinksDireccionamiento: [
                {
                    id: 1,
                    title: 'Direccionamientos por fecha',
                    subTitle: 'Descarga de direccionamientos especificando una fecha',
                    icon: 'ti ti-direction-alt',
                    color: 'purple',
                    type: 'date'
                },
                {
                    id: 2,
                    title: 'Direccionamientos por prescripción',
                    subTitle: 'Descarga de direccionamientos de una prescripción',
                    icon: 'ti ti-direction-alt',
                    color: 'info',
                    type: 'prescription'
                }
            ],
            donwloadLinksProgramacion: [
                {
                    id: 1,
                    title: 'Programaciones por fecha',
                    subTitle: 'Descarga de programaciones especificando una fecha',
                    icon: 'ti ti-timer',
                    color: 'purple',
                    type: 'date'
                }
            ],
            donwloadLinksHistorico: [],
            typeDownloadPrescripcion: null,
            typeDownloadDireccionamiento: null,
            typeDownloadProgramacion: null,
            typeDownloadHistorico: null,
            processing: false,
            tokens: []
        }),
        computed: {
            ...mapGetters([
                'activesMenus',
                'typeEmpresa'
            ]),
            ...mapState({
                tokensMIPRES: state => state.auth.tokensMIPRES
            }),
            permisos() {
                return {
                    mipres: this.$store.getters.getPermissionModule('mipres'),
                    prescripciones: this.$store.getters.getPermissionModule('prescripciones'),
                    direccionamientos: this.$store.getters.getPermissionModule('direccionamientos'),
                    programaciones: this.$store.getters.getPermissionModule('programaciones')
                }
            }
        },
        created() {
            if (this.permisos.prescripciones.descargar) this.donwloadLinksHistorico.push({
                id: 1,
                title: 'Histórico de prescripciones',
                subTitle: 'Descarga histórico de prescripciones especificando un rango de fechas',
                icon: 'ti ti-import',
                color: 'blue',
                type: 'histórico',
                show: ['IPS'],
                url: 'prescripcionesHistorico'
            })
            if (this.permisos.prescripciones.sincronizar) this.donwloadLinksHistorico.push({
                id: 2,
                title: 'Sincronización de prescripción por número',
                subTitle: 'Sincroniza todos los procesos especificando el número de una prescripción',
                icon: 'ti ti-wand',
                color: 'blue',
                type: 'sincronización',
                show: ['IPS', 'Farmacia'],
                url: 'prescriptionsync'
            })
        },
        methods: {
            openDialogDownloadPrescripciones(type) {
                this.typeDownloadPrescripcion = type
                this.$refs.dialogDPres.open()
            },
            openDialogDownloadDireccionamientos(type) {
                this.typeDownloadDireccionamiento = type
                this.$refs.dialogDD.open()
            },
            openDialogDownloadProgramaciones(type) {
                this.typeDownloadProgramacion = type
                this.$refs.dialogDP.open()
            },
            openDialogDownloadHistorico(type, url) {
                this.typeDownloadHistorico = type
                this.$refs.dialogDH.open(url)
            },
            openRegisterMainToken() {
                this.$refs.dialogRegisterMainToken.open()
            },
            openConfirmTokenDaily() {
                this.$refs.dialogTokenDaily.open()
            },
            refreshTokenDaily() {
                this.$refs.dialogTokenDaily.loading()
                this.axios.get('dailyToken')
                    .then(response => {
                        this.$store.dispatch('getTokensMIPRES')
                        this.$refs.dialogTokenDaily.close()
                        this.$store.commit('snackbar', {
                            color: 'success',
                            message: `${this.typeEmpresa === 'IPS' ? 'Los tokens se han' : 'El token se ha'} generado correctamente.`
                        })
                    }).catch(e => {
                    this.$refs.dialogTokenDaily.loading(false)
                    this.$store.commit('snackbar', {color: 'error', message: `al generar el token diario`, error: e})
                })
            }
        }
    }
</script>
